import FuxHTTP from "../../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../../APIConfig";
import AuthAPI from "../../AuthAPI";

export const _Reservations = {
    getFullReservationInfo: (reservation_id) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-events/event/reservations/full-info`),
            {
                token: AuthAPI.getUserAccessToken(),
                reservation_id: reservation_id,
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    changeReservationStatus: (reservation_id, new_status) => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-events/event/reservations/change-status`),
            {
                token: AuthAPI.getUserAccessToken(),
                reservation_id: reservation_id,
                new_status: new_status
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    reservationPagination: (event_id, cursor) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-events/event/reservations/pagination`),
            {
                token: AuthAPI.getUserAccessToken(),
                event_id: event_id,
                cursor: cursor
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    book: reservation => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-events/event/reservations/book`),
            {
                token: AuthAPI.getUserAccessToken(),
                ...reservation
            },
            FuxHTTP.RESOLVE_RESPONSE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    deleteReservation: (reservation_id) => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-events/event/reservations/delete`),
            {
                token: AuthAPI.getUserAccessToken(),
                reservation_id: reservation_id
            },
            FuxHTTP.RESOLVE_RESPONSE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
}
